import { siteInfo, categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                丫丫影院
              </span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-xs">
              {siteInfo.slogan}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              影视分类
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                品牌介绍
              </Link>
              <a
                href={`mailto:${siteInfo.email}`}
                className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                {siteInfo.email}
              </a>
              <span className="text-sm text-background-50/60 whitespace-nowrap">
                {siteInfo.phone}
              </span>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            {siteInfo.copyright}
          </p>
          <p className="text-xs text-background-50/30">
            本站资源仅供学习交流，请勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}